export default class ScrollTo {

    constructor() {
        this.settings = {
            button: document.querySelector('.js-scroll-to')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.button != null) {
            const scrollLink = document.querySelector(".js-scroll-to");

            if (scrollLink) {
                scrollLink.addEventListener("click", function(event) {
                    event.preventDefault();

                    const sectionId = scrollLink.getAttribute("href").substring(1);
                    scrollToTarget(sectionId);
                });
            }

            const scrollToTarget = (sectionId) => {
                const targetElement = document.getElementById(sectionId);

                if (targetElement) {
                    const offset = 119;
                    const targetPosition = targetElement.offsetTop - offset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        };

    }

}

new ScrollTo();
